import { useLlmTokenUsageService, useLlmConsentService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';

export function useChatInputState(defaultPlaceholder: string) {
  const usageService = useLlmTokenUsageService();
  const { data: usageData } = useDataLoaderNew(usageService.getUsage);

  const consentService = useLlmConsentService();
  const { data: consentData } = useDataLoaderNew(consentService.getConsent);

  const isLimitReached = usageData ? usageData.percentUsed >= 100 : false;
  const isNotOptedIn = consentData !== null && !consentData.optedIn;
  const isDisabled = isLimitReached || isNotOptedIn;

  let placeholder: string;
  if (isNotOptedIn) {
    placeholder = 'AI Chat needs to be enabled first';
  } else if (isLimitReached) {
    placeholder = 'Your team has used its included AI usage';
  } else {
    placeholder = defaultPlaceholder;
  }

  return {
    isDisabled,
    placeholder,
  };
}
